import { Col, Row, Table } from "reactstrap";
import { getElectricityInfo } from "../../../api/api";
import { useEffect, useState } from "react";
import { formatNumber, formatPower } from "../../../utils/NumberUtils";
import Spinner from "../../../commons/Spinner";

const TablePvPc20 = ({ selected, setSelected, deviceArr, deviceId }) => {
    const [pcsData, setPcsData] = useState(null);
    const authToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setPcsData(null);
        setIsLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async (signal) => {
            const data = await getElectricityInfo(authToken, deviceId, selected, signal);
            if (!data || data === null) {
                setPcsData({
                    ac_curr_phs_l1: 0,
                    ac_curr_phs_l2: 0,
                    ac_curr_phs_l3: 0,
                    ac_volt_phs_l1: 0,
                    ac_volt_phs_l2: 0,
                    ac_volt_phs_l3: 0,
                    dc_curr_str1: 0,
                    dc_curr_str2: 0,
                    dc_curr_str3: 0,
                    dc_curr_str4: 0,
                    dc_curr_str5: 0,
                    dc_curr_str6: 0,
                    dc_volt_mppt1: 0,
                    dc_volt_mppt2: 0,
                    dc_volt_mppt3: 0,
                    dc_volt_mppt4: 0,
                    dc_volt_mppt5: 0,
                    dc_volt_mppt6: 0,
                    device_id: "PV_50KW_PCS_1",
                    error_code: 0,
                    freq: 0,
                    measured_time: "2022/03/15 12:58:00",
                    power_factor: 0,
                    power_gene_str: 0,
                    time: 1647316753,
                    work_status: 115,
                })
            } else {
                setPcsData(data);
            } setIsLoading(false)
        };
        const interval = setInterval(() => {
            fetchData(signal);
        }, 60000);
        fetchData(signal);
        return () => {
            clearInterval(interval);
            controller.abort();
        };
        //eslint-disable-next-line
    }, [selected]);

    return (
        <>{isLoading ? <Spinner /> : <Row>
            <Col md={2} lg={2} sm={2} xl={1} className="col-2 d-flex flex-row justify-content-end arrow-menu h-100">
                <div>
                    <button
                        className="btn_back"
                        onClick={() => setSelected(null)}
                    >
                        <img src="/img/left.png" alt="leftArrow" />
                    </button>
                </div>
                <div className="vl">

                </div>
            </Col>
            <Col md={10} lg={10} sm={10} xl={11} className="col-9">
                <Row className="d-flex flex-row mx-1">
                    <div className="dropDown">
                        <select
                            type="select"
                            size="sm"
                            className="btn__dropdown"
                            value={selected.device_id}
                            onChange={(e) => setSelected(deviceArr.filter(el => (el.device_id === e.target.value))[0])}
                        >
                            {(deviceArr.length > 0) && deviceArr.map((el, i) => <option value={el.device_id} key={i} > {el.device_id} </option>)}
                        </select>
                    </div>
                    <div className="batteryBox">
                        <div className="colBorder">
                            <Row className="justify-content-center"><img src="/img/pcsImage.png" alt="pv-pcs" className="pv-pcs py-1" />
                            </Row>
                            <Row className="mb-4 mt-4 justify-content-center">
                                {pcsData !== null && <span className="pcsdata">{pcsData.device_id}</span>}
                            </Row>
                        </div>
                    </div>
                    <Col md={8} sm={10} lg={7} className="individual-battery">
                        <div className="scroll-bar">
                            {(pcsData !== null) && <Table className="power__data">
                                <tbody>
                                    <tr>
                                        <td>累計発電量 </td>
                                        <td>{formatPower(pcsData.power_gene_str, 2)}h</td>
                                    </tr>
                                    <tr>
                                        <td>有効電力</td>
                                        <td>{formatPower(pcsData.real_power, 2)}</td>
                                    </tr>
                                    <tr>
                                        <td>力率</td>
                                        <td>{formatNumber(pcsData.power_factor, 3)}</td>
                                    </tr>
                                    <tr>
                                        <td>周波数</td>
                                        <td>{formatNumber(pcsData.freq, 2)}Hz</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧1</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv1, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧2</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv2, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧3</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv3, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧4</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv4, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧5</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv5, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧6</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv6, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧7</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv7, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧8</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv8, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流1 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv1, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流2</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv2, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流3 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv3, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流4</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv4, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流5 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv5, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流6</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv6, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流7 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv7, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流8</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv8, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>系統電圧（A相）</td>
                                        <td>{formatNumber(pcsData.ac_volt_phs_l1, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>系統電圧（B相）</td>
                                        <td>{formatNumber(pcsData.ac_volt_phs_l2, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>系統電圧（C相）</td>
                                        <td>{formatNumber(pcsData.ac_volt_phs_l3, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>系統電流（A相）</td>
                                        <td>{formatNumber(pcsData.ac_curr_phs_l1, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>系統電流（B相）</td>
                                        <td>{formatNumber(pcsData.ac_curr_phs_l2, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>系統電流（C相）</td>
                                        <td>{formatNumber(pcsData.ac_curr_phs_l3, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>故障コード	</td>
                                        <td>{pcsData.event_code}</td>
                                    </tr>
                                    <tr>
                                        <td>アラーム1</td>
                                        <td>{pcsData.event_signal}</td>
                                    </tr>
                                    <tr>
                                        <td>アラーム2	</td>
                                        <td>{pcsData.event_signal2}</td>
                                    </tr>
                                    <tr>
                                        <td>アラーム3	</td>
                                        <td>{pcsData.event_signal3}</td>
                                    </tr>
                                </tbody>
                            </Table>}</div>
                    </Col>
                </Row>
            </Col>
        </Row>}
        </>
    );
};

export default TablePvPc20;
